import { Middleware } from 'redux';

// Converts uppercase event types to camelCase
// Ex: MY_EVENT -> myEvent
const typeToEvent = (type: string) =>
  type
    .split('_')
    .map(x => x.toLowerCase())
    .map((x, i) => (i === 0 ? x : x[0].toUpperCase() + x.slice(1)))
    .join('');

export interface EventData {
  [key: string]: any;
}

export const pushEvent = (name: string, data: EventData = {}) => {
  if (IS_SERVER || !window.dataLayer) {
    return;
  }

  const event = {
    event: name,
    [name]: data,
  };
  window.dataLayer.push(event);
};

const middleware: Middleware = () => next => action => {
  next(action);

  if (!window.dataLayer) {
    return;
  }

  switch (action.type) {
    case 'ROUTE_LOADED':
      break;
    // NOTE: Any changes done to data or structure of PRODUCT_PRICE_CLICK needs to be
    // reflected in react/middlewares/out.js pre click
    case 'PRODUCT_PRICE_CLICK':
    default: {
      const { type, ...rest } = action;

      const name = typeToEvent(type);
      pushEvent(name, rest);
    }
  }
};

export default middleware;
